'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseCta = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseCta = function BaseCta(_ref) {
  var children = _ref.children,
      className = _ref.className,
      classOptions = _ref.classOptions,
      _ref$tag = _ref.tag,
      tag = _ref$tag === undefined ? 'a' : _ref$tag,
      _ref$tooltipProps = _ref.tooltipProps,
      tooltipProps = _ref$tooltipProps === undefined ? {} : _ref$tooltipProps,
      otherProps = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className', 'classOptions', 'tag', 'tooltipProps']);

  var Tag = tag;

  return _react2.default.createElement(
    Tag,
    (0, _extends3.default)({
      className: (0, _classnames2.default)('bt bt--sm bt--text-sm schedule-item__cta', className, classOptions)
    }, tooltipProps, otherProps),
    children
  );
};

exports.BaseCta = BaseCta;
BaseCta.propTypes = {
  children: _propTypes2.default.any,
  className: _propTypes2.default.string,
  classOptions: _propTypes2.default.object,
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  tooltipProps: _propTypes2.default.exact({
    'data-tooltip': _propTypes2.default.string
  })
};